/** @format */

import React from 'react'
import { Tag } from '@king-design/react'

const THOUSAND_THRESHOLD = 1000

/** 是否按「xk」缩写展示（与 {@link formatCompactK} 规则一致：`abs(n) > 1000`） */
export function isCompactKNotation(n: number): boolean {
  return Number.isFinite(n) && Math.abs(n) > THOUSAND_THRESHOLD
}

/**
 * 将数字格式化为可读字符串：`abs(n) > 1000` 时用 `xk`，除法结果最多保留 2 位小数并去掉尾随 0；
 * 非有限数字返回 `—`。
 */
export function formatCompactK(n: number): string {
  if (!Number.isFinite(n)) return '—'
  const sign = n < 0 ? '-' : ''
  const abs = Math.abs(n)
  if (abs > THOUSAND_THRESHOLD) {
    const k = abs / THOUSAND_THRESHOLD
    const trimmed = k.toFixed(2).replace(/\.?0+$/, '')
    return `${sign}${trimmed}k`
  }
  return `${n}`
}

export interface CompactKDisplayProps {
  value: number
  className?: string
}

/** 按需使用 {@link formatCompactK}；大于 1000 与否则使用不同样式 */
const CompactKDisplay: React.FC<CompactKDisplayProps> = ({ value }) => {
  const isCompact = isCompactKNotation(value)
  return (
    <Tag border="solid" type={isCompact ? 'primary' : 'default'}>
      {formatCompactK(value)}
    </Tag>
  )
}

export default CompactKDisplay
